/**
 * Contract versioning fails closed.
 *
 * An unknown contract version is rejected, never best-guessed. This is the
 * smallest possible example of the product's governing principle: silence is
 * better than confident error.
 */

export const CONTRACT_VERSION = '1.0.0';

export const SUPPORTED_CONTRACT_VERSIONS: readonly string[] = [CONTRACT_VERSION];

export function assertContractVersion(version: string): void {
  if (!SUPPORTED_CONTRACT_VERSIONS.includes(version)) {
    throw new Error(
      `unsupported contract version ${JSON.stringify(version)}; ` +
        `supported: ${SUPPORTED_CONTRACT_VERSIONS.join(', ')}`,
    );
  }
}
